import React from 'react';
import { Link } from 'react-router-dom';
export function HeroSection() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="relative flex items-center px-5 md:px-10 lg:px-16 pt-8 md:pt-12 overflow-hidden min-h-screen lg:min-h-[700px]" data-id="element-86" data-mp="28tuwkxb8b3eo">
      <div className="absolute inset-0" data-id="element-87" data-mp="2wl0cfch65voz">
        <img src="https://cdn.magicpatterns.com/uploads/uUpuPt3gbZ7V5QdrqJgFQx/heylloyd-image-1782595699976.png" alt="Familia feliz y diversa con niños" className="w-full h-full object-cover" data-id="element-88" data-mp="2wm35nr1ysa82" />
        <div className="absolute inset-0" style={{
        background: 'linear-gradient(135deg, rgba(20, 80, 20, 0.65) 0%, rgba(0, 60, 10, 0.50) 50%, rgba(0, 40, 0, 0.40) 100%)'
      }} data-id="element-89" data-mp="2rs798t1cmvf0" />
      </div>

      <div className="relative max-w-5xl mx-auto text-center w-full pt-12 pb-20" data-id="element-90" data-mp="3kbe7lbv1wans">
        <img src="https://cdn.magicpatterns.com/uploads/4XjcpcjWQEZca1XxaXZTTT/pancita_feliz.png" alt="Pancita Feliz Foundation" className="animate-fade-in-down mx-auto mb-6" style={{
        width: '320px',
        height: 'auto',
        objectFit: 'contain',
        mixBlendMode: 'luminosity',
        filter: 'brightness(0) invert(1)',
        opacity: 0.95
      }} data-id="element-91" data-mp="2fg1rj3nttk0w" />

        <div className="flex items-center justify-center" style={{
        gap: '12px',
        marginBottom: '20px'
      }} data-id="element-92" data-mp="2u4xzl0pvux1i">
          <span style={{
          display: 'inline-block',
          width: '40px',
          height: '2px',
          background: '#7DC920',
          opacity: 0.8,
          verticalAlign: 'middle'
        }} data-id="element-93" data-mp="381tn1y6vsr13" />
          <span className="text-xs md:text-sm font-bold tracking-widest uppercase" style={{
          color: '#7DC920',
          textShadow: '0 0 20px rgba(125, 201, 32, 0.6)'
        }} data-id="element-94" data-mp="18sdaqmh8ka54">
            Descubre • Conecta • Evoluciona
          </span>
          <span style={{
          display: 'inline-block',
          width: '40px',
          height: '2px',
          background: '#7DC920',
          opacity: 0.8,
          verticalAlign: 'middle'
        }} data-id="element-95" data-mp="3iqpr5s622xgt" />
        </div>

        <h1 className="text-2xl md:text-4xl lg:text-5xl font-bold text-white mb-6 leading-tight drop-shadow-lg mx-auto max-w-4xl" data-id="element-96" data-mp="l49u1d17wmu">
          Apoyamos a familias con niños neurodiversos a acceder a lo que
          necesitan
        </h1>

        <p className="text-sm md:text-base lg:text-lg text-white opacity-90 mb-10 max-w-3xl mx-auto drop-shadow" data-id="element-97" data-mp="aaw6r28lt1uh">
          Eliminamos las barreras económicas que separan a las familias de la
          educación, orientación especializada y evaluaciones profesionales
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-98" data-mp="23v7lzodlj7w9">
          <Link to="/donar" className="w-full sm:w-auto inline-block text-center bg-primary text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-primary/90 transition-colors shadow-lg hover:shadow-xl" data-id="element-99" data-mp="1yv21qt9nono7">
            Donar Ahora
          </Link>
          <Link to="/solicitar-ayuda" className="w-full sm:w-auto inline-block text-center border-2 border-white text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-white hover:text-dark transition-colors" data-id="element-100" data-mp="2mlfkft6cpa64">
            Solicitar Ayuda
          </Link>
        </div>
      </div>
    </section>;
}